'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/6/22. ErrorLabel
                                          */

// import * as mainActions from 'redux/modules/main';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _background = require('redux/modules/background');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('艺品网首页')));
    promises.push(dispatch(authActions.isPersonalUserLoaded()));
    //  promises.push(dispatch(mainActions.load()));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.main.data,
    personalUserInfo: state.auth.personalUserInfo
  };
}, (0, _extends3.default)({}, authActions, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main() {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Main).call(this));

    _this.state = {
      rightCarouselImgsConst: [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/auction/auctionMain.jpg',
        url: '/experienceshopproductlist/M0043260000000000000000129'
      }, {
        img: 'http://tupian.goeasy.cn:9999/upload/201708/14/2055_3ba0bd4f-d550-4bc8-8542-d06258b58fd9.jpg'
        // url: '/intro'
      }, {
        img: 'http://tupian.goeasy.cn:9999/upload/201708/14/2055_63ffbba4-8e44-4f83-a22e-bcfcea9f047c.jpg'
        // url: '/intro'
      }],
      leftCarouselImgs: [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/diaosu.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/jinshu.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/qiqi.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/huahua.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/bianzhi.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/choushacixiu.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/ditanguatan.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/zhubaoshoushi.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/minzugongyi.jpg',
        url: '/home'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/gongdingzhi/taoci.jpg',
        url: '/home'
      }],
      bottomLeftCarouselImgs: [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/diaosu.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/jinshu.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/qiqi.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/huahua.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/bianzhi.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/choushacixiu.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/ditanguat.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/zhubaoshoushi.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/minzugongyi.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/yiyipin/taoci.jpg'
      }],
      bottomCenterCarouselImgs: [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/meifuwu/1.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/meifuwu/2.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/meifuwu/3.jpg'
      }],
      bottomRightCarouselImgs: [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/shubaike/1.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/shubaike/2.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/shubaike/3.jpg'
      }],
      sanZhenCarouselImgs: [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/zrzp_banner_bg1.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/zrzp_banner_bg2.jpg'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'onRouterUrl',
    value: function onRouterUrl(url) {
      var _props = this.props;
      var showUserLoginModel = _props.showUserLoginModel;
      var personalUserInfo = _props.personalUserInfo;

      if (personalUserInfo.isValid) {
        var win = window.open(url, '_blank');
        win.focus();
      } else {
        showUserLoginModel();
      }
    }
  }, {
    key: 'onRouterUrl2',
    value: function onRouterUrl2(url) {
      var win = window.open(url, '_blank');
      win.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Main.scss');
      //  const { data } = this.props;
      //  bottomLeftCarouselImgs, bottomCenterCarouselImgs, bottomRightCarouselImgs,
      var _state = this.state;
      var leftCarouselImgs = _state.leftCarouselImgs;
      var rightCarouselImgsConst = _state.rightCarouselImgsConst;

      var returnDiv = _react2.default.createElement(
        'div',
        { className: styles.rightCarousel },
        _react2.default.createElement(_components.GoeasyCarousel, { page: 'mainCenter', images: rightCarouselImgsConst })
      );
      /*  if (data) {
       const { rightCarouselImgs} = data;
       /!*
       if (rightCarouselImgsError) {
       returnDiv = (
       <div style={{width: '851px', height: '633px'}}>
       <ErrorLabel error={rightCarouselImgsError}/>
       </div>
       );
       } else  *!/
       if (rightCarouselImgs instanceof Array) {
       returnDiv = (
       <div className={styles.rightCarousel}>
       <GoeasyCarousel page="mainCenter" images={rightCarouselImgs}/>
       </div>
       );
       }
       } */
      return _react2.default.createElement(
        'div',
        { style: { width: '1280px' } },
        _react2.default.createElement(
          'div',
          { className: styles.leftCarousel },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: 'home', target: '_blank', className: styles.newBanText },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/images/main_img_8.png',
              alt: '' })
          ),
          _react2.default.createElement(_components.GoeasyCarousel, { page: 'mainOther', images: leftCarouselImgs })
        ),

        /*
         <div className={styles.rightCarousel}>
         <GoeasyCarousel page="mainCenter" images={rightCarouselImgs}/>
         </div>
         */
        returnDiv,
        _react2.default.createElement(
          'div',
          { className: styles.bottomCarousel },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/characteristicregional', target: '_blank', className: styles.new_a },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/main_img_1.jpg',
              alt: '' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bottomCarousel },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/customproductslist', target: '_blank', className: styles.new_a },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/main_img_2.jpg',
              alt: '' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bottomCarousel + ' ' + styles.marginRightZero },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/designerlist', target: '_blank', className: styles.new_a },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/main_img_3.jpg',
              alt: '' })
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.menu_vot },
          _react2.default.createElement(
            'div',
            { className: styles.back_box + ' ' + styles.img_none },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/images/back_img_1.png', alt: '' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/experienceshopfirstpage', target: '_blank' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/back_img_4.png', alt: '', className: styles.img_1 })
          ),
          _react2.default.createElement('div', { className: styles.shu_link + ' ' + styles.poa_a }),
          _react2.default.createElement(
            'div',
            { className: styles.back_box + ' ' + styles.img_none + ' ' + styles.poa_1 },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/images/back_img_2.png', alt: '' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: 'http://www.haoweisys.com/zgypw/bwg.html', target: '_blank' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/back_img_5.png', alt: '',
              className: styles.img_2 })
          ),
          _react2.default.createElement('div', { className: styles.shu_link + ' ' + styles.poa_b }),
          _react2.default.createElement(
            'div',
            { className: styles.back_box + ' ' + styles.img_none + ' ' + styles.poa_2 },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/images/back_img_3.png', alt: '' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/workstationlist', target: '_blank' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/back_img_6.png', alt: '',
              className: styles.img_3 })
          ),
          _react2.default.createElement('iframe', { src: 'http://tupian.goeasy.cn:9999/ypwMainVotur/ven/index.html', frameBorder: '0', width: '100%',
            height: '100%' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'section',
          { className: styles.new_lanmu },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/newmedium', target: '_blank', className: styles.lanmu3 + ' ' + styles.new_lanmu_float },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/main_img_4.jpg', alt: '' })
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/servicesmarket', target: '_blank',
              className: styles.lanmu3 + ' ' + styles.new_lanmu_float + ' ' + styles.new_lanmu_mr1 },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/main_img_5.jpg', alt: '' })
          ),
          _react2.default.createElement(
            'a',
            { href: 'http://baike.craftschina.cn/', target: '_blank',
              className: styles.lanmu3 + ' ' + styles.new_lanmu_float + ' ' + styles.new_lanmu_mr1 },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/images/main_img_6.jpg', alt: '' })
          )
        )
      );
    }
  }]);
  return Main;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  personalUserInfo: _react.PropTypes.object,
  isPersonalUserLoaded: _react.PropTypes.func,
  showUserLoginModel: _react.PropTypes.func,
  routerPush: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = Main;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Main/Main.js
 ** module id = 1493
 ** module chunks = 0
 **/